export const blockIconsSearchWindow = (
	<span className='material-symbols-outlined'>window</span>
);
